export function separateCountryCode(phoneNumber) {
	if (!phoneNumber) return { countryCode: null, localNumber: null };
	// Regex to capture the country code (1-3 digits) and the rest of the number.
	// It handles an optional '+' at the beginning.
	const regex = /^\+?(\d{1,3})(\d{7,})$/;

	const match = String(phoneNumber).replace(/[\s\(\)-]/g, '').match(regex);

	if (match) {
		return {
			countryCode: `+${match[1]}`,
			localNumber: match[2],
		};
	}

	return {
		countryCode: null,
		localNumber: phoneNumber,
	};
}
